import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DeliveryNoteService = {
  /**
   * Get Delivery Note Pallet Detail Complete
   * Fetches ALL pallet details (products, batches, pallets) in ONE call
   * Uses vw_DeliveryNotePalletDetail view for optimal performance
   * @param {Number} deliveryNote - Delivery Note number
   * @returns {Promise} API response with complete hierarchical data
   */
  async getDeliveryNotePalletDetailComplete(deliveryNote) {
    const requestScreenData = {
      url: "api/DeliveryNotePalletDetail",
      filter: `DeliveryNote eq ${deliveryNote} and ItemType ne 'G'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  /**
   * Get Delivery Note Detail
   * Fetches product details for a delivery note
   * @param {Object} params - Query parameters (filter, select, etc.)
   * @returns {Promise} API response with delivery note details
   */
  async getDeliveryNoteDetail(params) {
    const requestScreenData = {
      url: "api/DeliveryNoteDetail",
    };

    // Add filter if provided
    if (params && params.filter) {
      requestScreenData.filter = params.filter;
    }

    // Add select if provided
    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  /**
   * Get Invoice Product Batch
   * Fetches batch information for invoice products
   * @param {Object} params - Query parameters (filter, select, etc.)
   * @returns {Promise} API response with batch details
   */
  async getInvoiceProductBatch(params) {
    const requestScreenData = {
      url: "api/InvoiceProductBatch",
    };

    // Add filter if provided
    if (params && params.filter) {
      requestScreenData.filter = params.filter;
    }

    // Add select if provided
    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  /**
   * Get Picking Slip Log
   * Fetches pallet information from picking slip log
   * @param {Object} params - Query parameters (filter, select, etc.)
   * @returns {Promise} API response with pallet details
   */
  async getPickingSlipLog(params) {
    const requestScreenData = {
      url: "api/PickingSlipLog",
    };

    // Add filter if provided
    if (params && params.filter) {
      requestScreenData.filter = params.filter;
    }

    // Add select if provided
    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  /**
   * Update Pallet Details
   * Updates pallet information for a delivery note
   * @param {Object} data - Update payload containing DeliveryNote and Changes array
   * @returns {Promise} API response
   */
  async updatePalletDetails(data) {
    const url = "api/Save_PickingSlip/PalletInfo";
    return await ApiService.post(url, data);
  },
};

export { DeliveryNoteService };